module.exports = __webpack_public_path__ + "static/media/deactivate_user.8a7726f3.svg";